import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../reducers/types";
import { ExperiencesSearch } from "./component";
import {
  getFetchRewardsAccountsCallState,
  getRewardsAccounts,
  getRewardsAccountWithLargestValue,
} from "../rewards/reducer";
import { fetchRewardsAccounts } from "../rewards/actions/actions";
import { setEntryType, setLocation , fetchTripDestinations } from "./actions/actions";
import { fetchTravelWalletDetails } from "../travel-wallet/actions/actions";
import {
  getTripDestinations,
  getTripDestinationsLoaded,
  getEntryTypesAll,
} from "./reducer";

const mapStateToProps = (state: IStoreState) => ({
  rewardsAccounts: getRewardsAccounts(state),
  largestValueAccount: getRewardsAccountWithLargestValue(state),
  fetchRewardsAccountsCallState: getFetchRewardsAccountsCallState(state),
  tripDestinations: getTripDestinations(state),
  tripDestinationsLoaded: getTripDestinationsLoaded(state),
  entryTypesAll: getEntryTypesAll(state),
});

const mapDispatchToProps = {
  fetchRewardsAccounts,
  setLocation,
  fetchTravelWalletDetails,
  setEntryType,
  fetchTripDestinations,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ExperiencesSearchConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedExperiencesSearch = withRouter(
  connector(ExperiencesSearch)
);
